/**
 * Footer component
 */

import * as React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import parse from "html-react-parser"
import { FaFacebook, FaYoutube, FaInstagram } from "react-icons/fa"
import FlagEn from "./icons/flag-en"

const FooterContents = class extends React.Component {
  componentDidMount() {
    const translateScript1 = document.createElement("script")
    translateScript1.async = true
    translateScript1.innerText = `function googleTranslateElementInit() { new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element'); }`
    document.body.appendChild(translateScript1)
    const translateScript2 = document.createElement("script")
    translateScript2.async = true
    translateScript2.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    document.body.appendChild(translateScript2)
  }

  render() {
    const { data } = this.props
    const menuItemsSitemap = data?.sitemap?.nodes
    const menuItemsContact = data?.contact?.nodes
    const menuItemsSocials = data?.socials?.nodes

    const policies = [
      {
        title: "Privacy Policy",
        url: "/privacy-policy",
      },
      {
        title: "Terms of Use",
        url: "/terms-of-use",
      },
      {
        title: "Disclaimer",
        url: "/disclaimer",
      },
      {
        title: "Cookie Policy",
        url: "/cookie-policy",
      },
      {
        title: "Privacy Settings",
        id: "usercentrics-psl",
      }
    ]

    return (
      <footer className="text-white print:hidden">
        <div className="bg-gray-900">
          <div className="container py-8 lg:py-12">
            <div className="relative flex-wrap justify-between flex">
              <div className="mb-6">
                <ul className="lg:leading-normal">
                  {menuItemsSitemap.map((c1, index) => {
                    return (
                      <>
                        {index === 0 ? (
                          <li className="h3 mb-2" key={"menu-" + index}>
                            {c1.title ? parse(c1.title) : null}
                          </li>
                        ) : (
                          <li key={"menu-" + index}>
                            <a href={c1.url} className={`footer-link`}>
                              {c1.title ? c1.title : null}
                            </a>
                          </li>
                        )}
                      </>
                    )
                  })}
                </ul>
              </div>
              <div className="mb-6">
                <ul>
                  {menuItemsContact.map((c1, index) => {
                    return (
                      <>
                        {index === 0 ? (
                          <li className="h3 mb-2" key={"menu-" + index}>
                            <Link
                              to={c1.url}
                              className="text-white hover:text-green"
                            >
                              {c1.title ? parse(c1.title) : null}
                            </Link>
                          </li>
                        ) : (
                          <li key={"menu-" + index}>
                            {c1.description}
                            <a
                              href={c1.url}
                              target="_blank"
                              rel="noreferrer"
                              className={`footer-link`}
                            >
                              {c1.title ? parse(c1.title) : null}
                            </a>
                          </li>
                        )}
                      </>
                    )
                  })}
                </ul>
              </div>
              <div className="mb-6">
                <ul className="mb-8">
                  {menuItemsSocials.map((c1, index) => {
                    return (
                      <>
                        {index === 0 ? (
                          <li className="h3 mb-4" key={"menu-" + index}>
                            {c1.title ? c1.title : null}
                          </li>
                        ) : (
                          <li key={"menu-" + index} className="inline-block">
                            <a
                              href={c1.url}
                              target="_blank"
                              rel="noreferrer"
                              className={`footer-link inline-block grow mr-4 mb-3 text-3xl`}
                              title={c1.title}
                            >
                              {c1.title === "Facebook" ? (
                                <FaFacebook />
                              ) : c1.title === "YouTube" ? (
                                <FaYoutube />
                              ) : c1.title === "Instagram" ? (
                                <FaInstagram />
                              ) : (
                                <span className="text-base">{c1.title}</span>
                              )}
                            </a>
                          </li>
                        )}
                      </>
                    )
                  })}
                </ul>
                <h3 className="mb-4">Translate</h3>
                <div
                  title="Language Translation"
                  className="text-white flex items-start target"
                  id="translate"
                >
                  <span className="sr-only">Language Translation</span>
                  <div className="relative mt-1 mr-3">
                    <FlagEn aria-hidden className="w-8" />
                  </div>
                  <div className="relative">
                    <span className="target-icon inset-0 absolute w-full h-full">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green opacity-40"></span>
                    </span>
                    <div
                      className="relative"
                      dangerouslySetInnerHTML={{
                        __html: "",
                      }}
                      id="google_translate_element"
                    ></div>
                  </div>
                  {/* TO-DO: Add Google Translate buttons for English & Spanish (eg https://www.un-page.org) */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-red-1000 py-16">
          <div className="text-xs container">
            <div className="flex flex-wrap justify-between items-center">
              <div className="sm:w-3/4 mb-6">
                <p>
                  Copyright © {new Date().getFullYear()}. All Rights reserved.
                </p>
                <p>
                  The Community Foundation of Northern Nevada, a 501 (c) 3
                  organization, is established to strengthen our region through
                  leadership and philanthropy by connecting people who care with
                  causes that matter.
                </p>
                <p>Your contribution may be tax-deductible under federal law.</p>
                <p>EIN: 88-0370179</p>
              </div>
              <div>
                <a href="https://www.cfstandards.org/the-program" target={`_blank`} rel="noreferrer noopener">
                  <img
                    src="/images/National Standards Seal White.png"
                    alt="CFNS Accredited Foundation"
                    className="w-24"
                  />
                </a>
              </div>
            </div>
            <nav>
              <ul className="flex flex-wrap divide-x divide-gray-500 -mx-2">
                {policies.map((policy, index) => {
                  return (
                    <>{policy.id === "usercentrics-psl" ?
                      <li dangerouslySetInnerHTML={{
                        __html: `<button class="text-white hover:text-green px-2" onClick="UC_UI.showSecondLayer();" id="usercentrics-psl">Privacy Settings</button>`,
                      }} />
                      :
                      <li key={`policy-${index}`}>
                        <Link
                          to={policy.url}
                          id={policy.id}
                          className="text-white hover:text-green px-2"
                        >
                          {policy.title}
                        </Link>
                      </li>
                    }
                    </>
                  )
                })}
              </ul>
            </nav>
          </div>
        </div>
      </footer>
    )
  }
}
const Footer = () => {
  return (
    <StaticQuery
      query={graphql`
        query footerQuery {
          sitemap: allMenuItems(
            filter: {
              menu_name: { eq: "footer" }
              parent: { id: { eq: null } }
            }
            sort: { order: DESC, fields: weight }
          ) {
            nodes {
              url
              title
            }
          }
          contact: allMenuItems(
            filter: { menu_name: { eq: "footer-contact" } }
          ) {
            nodes {
              url
              title
              description
            }
          }
          socials: allMenuItems(
            filter: { menu_name: { eq: "footer-socials" } }
          ) {
            nodes {
              url
              title
            }
          }
        }
      `}
      render={data => <FooterContents data={data} />}
    />
  )
}
export default Footer
